import { debounce } from "lodash";
import moment from "moment";
import { call, delay, put, select } from "redux-saga/effects";
import { SetVisibleTimelinePeriodAction, scheduleActions, default as actions, SetLoadedTimelinePeriodAction } from '../../actions';
import { LOADED_TIMELINE_STORAGE_KEY, VISIBLE_TIMELINE_STORAGE_KEY } from "../../reducers";
import {getIsLoadingEntriesQuietly, getIsTimelineLoading, getLoadedTimelineBufferPeriod, getLoadedTimelinePeriod} from "../../selectors";
import { selectVisibleTimelinePeriodSaga } from "../../selectors-saga";
import { loadAll } from "../timelineEntries/fetchAllEntries";

const debouncedPersist = debounce((data) => {
  localStorage.setItem(VISIBLE_TIMELINE_STORAGE_KEY, JSON.stringify({ start: data.getStartMs(), end: data.getEndMs() }))
}, 500);

export function* watchSetVisibleTimelinePeriod(action: SetVisibleTimelinePeriodAction) {
  const loadedTimelinePeriod = yield select(getLoadedTimelinePeriod);
  const currVisibleTimelinePeriod = action?.payload?.visibleTimelinePeriod;
  const currMid = currVisibleTimelinePeriod?.getMidpoint();

  debouncedPersist(currVisibleTimelinePeriod);

  const twoMonthsInMs = 5.184E9;

  let isStillLoading = yield select(getIsTimelineLoading);
  if (!isStillLoading) {
    if (currMid - loadedTimelinePeriod.start < twoMonthsInMs) {
      yield put(scheduleActions.setTimelineLoading(true));
      const newStart = loadedTimelinePeriod.start - twoMonthsInMs * 2
      const newEnd = loadedTimelinePeriod.end - twoMonthsInMs * 2
      const [from, to] = [
        moment(newStart).format(),
        moment(loadedTimelinePeriod.start).format(),
      ];
      yield put(scheduleActions.setLoadedTimelinePeriod({ start: newStart, end: newEnd }))
      yield call(loadAll, from, to, 'left', newEnd);
      localStorage.setItem(LOADED_TIMELINE_STORAGE_KEY, JSON.stringify({ start: newStart, end: newEnd }))
    }

    if (loadedTimelinePeriod.end - currMid < twoMonthsInMs) {
      yield put(scheduleActions.setTimelineLoading(true));
      const newStart = loadedTimelinePeriod.start + twoMonthsInMs * 2
      const newEnd = loadedTimelinePeriod.end + twoMonthsInMs * 2
      const [from, to] = [
        moment(loadedTimelinePeriod.end).format(),
        moment(newEnd).format(),
      ];
      yield put(scheduleActions.setLoadedTimelinePeriod({ start: newStart, end: newEnd }))
      yield call(loadAll, from, to, 'right', newStart);
      localStorage.setItem(LOADED_TIMELINE_STORAGE_KEY, JSON.stringify({ start: newStart, end: newEnd }))
    }
    yield put(scheduleActions.setTimelineLoading(false));
  }

  // isStillLoading = yield select(getIsLoadingEntriesQuietly);
  // if (isStillLoading && (yield* isBufferPeriodLimitVisible()) ) {
  //   yield put(scheduleActions.setState({ isLoadingMoreEntries: true, isTimelineLoading: true }));
  //   while(true) {
  //     yield delay(10);
  //     isStillLoading = yield select(getIsLoadingEntriesQuietly);
  //     if (!isStillLoading) {
  //       yield put(scheduleActions.setState({ isLoadingMoreEntries: false, isTimelineLoading: false }));
  //       break;
  //     }
  //   }
  // }
}

function* isBufferPeriodLimitVisible() {
  const visibleTimelinePeriod = yield* selectVisibleTimelinePeriodSaga();
  const loadedTimelineBufferPeriod = yield select(getLoadedTimelineBufferPeriod);

  if (loadedTimelineBufferPeriod) {
    if (
      // timeline buffer start is visible
      (visibleTimelinePeriod.getStart().isBefore(loadedTimelineBufferPeriod.getStart()) &&
        visibleTimelinePeriod.getEnd().isAfter(loadedTimelineBufferPeriod.getStart())) ||
      // timeline buffer end is visible
      (visibleTimelinePeriod.getStart().isBefore(loadedTimelineBufferPeriod.getEnd()) &&
        visibleTimelinePeriod.getEnd().isAfter(loadedTimelineBufferPeriod.getEnd())) ||
      // visible timeline is bigger than the buffer—resize buffer and fetch with loading bar
      (visibleTimelinePeriod.getStart().isBefore(loadedTimelineBufferPeriod.getStart()) &&
        visibleTimelinePeriod.getEnd().isAfter(loadedTimelineBufferPeriod.getEnd()))
    ) {
      return true;
    }
  }
  return false;
}

